var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"px-4 py-2",attrs:{"row":"","wrap":"","fill-height":"","justify-center":"","align-center":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs6":""}},[_c('div',{staticClass:"subheading font-weight-light"},[_vm._v(_vm._s(_vm.$t('homepage.select_examination')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }